export default __webpack_public_path__ + "static/media/ellie8.fc8d2410.jpg";